import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { withSentryReactRouterV6Routing } from '@sentry/react';
import footers from '../../routes/footerRoutes';

const SentryRoutes = withSentryReactRouterV6Routing(Routes);
const FooterRoutes = () => {
	return (
		<SentryRoutes>
			{footers.map((page) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Route key={page.path} {...page} />
			))}
		</SentryRoutes>
	);
};

export default FooterRoutes;
